module.exports = __webpack_public_path__ + "img/thunderstorm-thumb.a8115603.jpg";